/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { NDCDetailsTextFieldComponent } from '../../../../Display/NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';

import TextField from '@material-ui/core/TextField';

import { getRebateProgramCode } from '../../OnlineFixes/CreateStubInvoice/store/action';
import { setComponentData } from '../store/action';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import { setClientSearchDataAction } from '../../../../../Modules/Maintain/client/store/actions';
import {
  QUARTER_FORMAT_ERROR,
  CLIENT_ID_REQUIRED,
  BEGIN_QUATER_REQ,
  END_QUATER_REQ,
  FUTURE_QUARTER_ERROR,
} from '../../../../../SharedModules/Errors/constantMessageData';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import TransitionDataActionButtons from './TransitionDataActionButtons';
import { checkQuaterIsValid } from '../../../../Invoice/RequestDrugPriceLoad/component/RequestDrugPriceLoadManufactureTable';
import {
  setPlanType,
  setRebateProgram,
  setStartDate,
  setEndDate,
  setErrors,
  setRbtPrgDD,
} from '../store/action';
import { autoFormateDate } from '../../../../../SharedModules/utilities/utilities';

const TransitionDataClaimFiles = ({ setErrorMessages, setSuccessMessages }) => {
  const [clientDD, setClientDD] = useState([]);
  const [disableRun, setdisableRun] = useState(true);
  const dispatch = useDispatch();
  const checkTargetQtrIsFuture = (quater, calcQtr) => {
    const targetQtr = quater;
    if (calcQtr) {
      if (targetQtr.split('Q')[1] > calcQtr.split('Q')[1]) {
        return true;
      } else if (
        targetQtr.split('Q')[1] === calcQtr.split('Q')[1] &&
        targetQtr.split('Q')[0] > calcQtr.split('Q')[0]
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const planType = useSelector(
    (state) => state.sharedState?.TransitionData?.planType
  );
  const rebateProgram = useSelector(
    (state) => state.sharedState?.TransitionData?.rebateProgram
  );
  const startDate = useSelector(
    (state) => state.sharedState?.TransitionData?.startDate
  );
  const endDate = useSelector(
    (state) => state.sharedState?.TransitionData?.endDate
  );
  const errors = useSelector(
    (state) => state.sharedState?.TransitionData?.errors
  );
  const rbtPrgDD = useSelector(
    (state) => state.sharedState?.TransitionData?.rbtPrgDD
  );

  const validFilter = (filterValue) => {
    let localErrorMessage = [];
    let localErrors = {};
    setErrorMessages([]);
    dispatch(setErrors({}));

    if (!rebateProgram || rebateProgram == -1) {
      localErrorMessage.push(CLIENT_ID_REQUIRED);
      localErrors['rpc'] = true;
    }

    if (!startDate) {
      localErrorMessage.push(BEGIN_QUATER_REQ);
      localErrors['startDate'] = true;
    } else {
      localErrors['startDate'] = false;
    }

    if (!endDate) {
      localErrorMessage.push(END_QUATER_REQ);

      localErrors['endDate'] = true;
    } else {
      localErrors['endDate'] = false;
    }
    if (
      startDate != null &&
      !checkQuaterIsValid(startDate) &&
      localErrors['startDate'] == false
    ) {
      if (!localErrorMessage.includes(QUARTER_FORMAT_ERROR)) {
        localErrorMessage.push(QUARTER_FORMAT_ERROR);
      }
      localErrors['startDate'] = true;
    } else {
      localErrors['startDate'] = false;
    }
    if (
      endDate != null &&
      !checkQuaterIsValid(endDate) &&
      localErrors['endDate'] == false
    ) {
      if (!localErrorMessage.includes(QUARTER_FORMAT_ERROR)) {
        localErrorMessage.push(QUARTER_FORMAT_ERROR);
      }
      localErrors['endDate'] = true;
    } else {
      localErrors['endDate'] = false;
    }
    if (endDate && startDate && checkTargetQtrIsFuture(startDate, endDate)) {
      localErrorMessage.push(FUTURE_QUARTER_ERROR);
    }

    if (localErrorMessage.length > 0) {
      setErrorMessages(localErrorMessage);
      dispatch(setErrors(localErrors));
      setdisableRun(true);
      return false;
    } else {
      setErrorMessages([]);
      dispatch(setErrors({}));
      setdisableRun(false);
      return true;
    }
  };

  const rebateDropdownData = useSelector(
    (state) => state.sharedState.createStubInvoice.rebateDropdownData
  );
  const pageData = useSelector(
    (state) => state.sharedState?.TransitionData?.pageData
  );
  const defaultPlanType = useSelector(
    (state) =>
      state.sharedState.UserDefaultReducer.UserDefaultsValues.data.planTypeCd
  );
  const defaultRebateCd = useSelector(
    (state) =>
      state.sharedState.UserDefaultReducer.UserDefaultsValues.data
        .rebateProgramCd
  );
  const clientSearchData = useSelector((state) => {
    return state.sharedState.ClientReducer.clientSearchData;
  });

  useEffect(() => {
    axios
      .post(serviceEndPoint.GET_ALL_CLIENTS, { route: 'getAllClients' })
      .then((response) => {
        const data = response?.data?.data;

        dispatch(
          setClientSearchDataAction(data && data.length > 0 ? data : [])
        );
      })
      .catch(() => {
        dispatch(setClientSearchDataAction([]));
      });
    // const list = rebateDropdownData.map((item) => {
    //   return { ...item, label: null };
    // });
    // dispatch(setRbtPrgDD(list));
  }, []);
  useEffect(() => {
    let ddData = clientSearchData?.map((x) => {
      return { value: x.clientId, label: null };
    });
    setClientDD(ddData);
  }, [clientSearchData]);

  // useEffect(() => {
  //   dispatch(getRebateProgramCode(planType));
  //   if (planType != defaultPlanType) dispatch(setRebateProgram(null));
  //   else if (!rebateProgram) dispatch(setRebateProgram(defaultRebateCd));
  // }, [planType]);

  useEffect(() => {
    if (startDate != null || endDate != null || rebateProgram == -1)
      validFilter();
    const componentData = {
      rebateProgram: rebateProgram,
      startDate: startDate,
      endDate: endDate,
    };
    dispatch(setComponentData(componentData));
  }, [rebateProgram, startDate, endDate]);

  // useEffect(() => {
  //   dispatch(getRebateProgramCode(defaultPlanType));
  //   dispatch(setPlanType(defaultPlanType));
  // }, [defaultPlanType]);

  useEffect(() => {
    if (startDate == null) {
      dispatch(setStartDate(pageData.startDate));
    }
    if (endDate == null) {
      dispatch(setEndDate(pageData.endDate));
    }
  }, []);

  const buttonClickHandler = async (actionType) => {
    if (!validFilter()) {
      return false;
    }
    const payLoad = {
      clientId: rebateProgram,
      beginQtr: startDate,
      endQtr: endDate,
      runCd: actionType,
    };
    const response = await axios.post(
      serviceEndPoint.TRANSITION_DATA_GET_CLAIM_FILE_URL,
      payLoad
    );
    setSuccessMessages([response?.data]);
  };
  return (
    <>
      <div
        className="col-12 mt-2"
        style={{ display: 'flex' }}
        data-testid="claim-data-detail"
      >
        <div className="col-3 mt-2" data-testid="claim-clientId">
          <NDCDetailsTextFieldComponent
            label="Client ID"
            required={true}
            value={rebateProgram}
            error={(errors && errors.rpc) || false}
            className="ml-0 with-select"
            select={true}
            selectReset={true}
            selectData={clientDD}
            disabled={false}
            onChange={(e) => {
              dispatch(setRebateProgram(e.target.value));
              setSuccessMessages([]);
              //validFilter();
            }}
          />
        </div>
        <div className="col-2 mt-2">
          <div className="dif no-margin">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                data-test="start-date"
                id="beginDate"
                label="Begin Qtr"
                fullWidth
                placeholder=""
                inputProps={{ maxlength: 6 }}
                InputLabelProps={{
                  shrink: true,
                }}
                error={errors && errors.startDate}
                required
                name="quarter"
                value={startDate}
                onBlur={(e) => {
                  dispatch(
                    setStartDate(autoFormateDate(e.target.value?.toUpperCase()))
                  );
                  if (!endDate) {
                    dispatch(
                      setEndDate(autoFormateDate(e.target.value?.toUpperCase()))
                    );
                  }
                }}
                onChange={(e) => {
                  dispatch(setStartDate(e.target.value));
                  setSuccessMessages([]);
                  //validFilter();
                }}
              ></TextField>
            </div>
          </div>
        </div>
        <div className="col-2 mt-2">
          <div className="dif no-margin">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <div className="mui-custom-form with-select input-md">
                <TextField
                  data-test="end-date"
                  id="endDate"
                  label="End Qtr"
                  fullWidth
                  placeholder=""
                  inputProps={{ maxlength: 6 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors && errors.endDate}
                  required
                  name="quarter"
                  value={endDate}
                  onChange={(e) => {
                    dispatch(setEndDate(e.target.value));
                    setSuccessMessages([]);
                  }}
                  onBlur={(e) => {
                    dispatch(
                      setEndDate(autoFormateDate(e.target.value?.toUpperCase()))
                    );
                  }}
                ></TextField>
              </div>
            </MuiPickersUtilsProvider>
          </div>
        </div>
      </div>

      <div className="col-md">
        <TransitionDataActionButtons
          onButtonClick={buttonClickHandler}
          disabled={disableRun}
        />
      </div>
    </>
  );
};

export default TransitionDataClaimFiles;
